import React from 'react';
import { PropTypes } from 'prop-types';
import { compose } from 'redux';
import { navigateFindATutor } from 'shared/utilities/navigation';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import TutorCard from 'shared/components/FindATutor/components/TutorCard/TutorCard';
import SecondaryButtonV2 from 'shared/components/Buttons/SecondaryButtonV2/SecondaryButtonV2';
import withStyles from './schoolLandingPageStyles';

// eslint-disable-next-line arrow-body-style
const SchoolLanding = props => {
  return (
    <div className={props.classes.container}>
      <div className={props.classes.content}>
        <Typography className={props.classes.title} variant="h3">
          {props.title}
        </Typography>
        <Typography className={props.classes.subHeader} variant="body1">
          {
            'Create an account with Tutorfly to have sessions with qualified peer tutors near your area or online!'
          }
        </Typography>
      </div>
      <div>
        {props.tutors.map(tutor => (
          <div key={tutor.id}>
            <TutorCard key={tutor.id} tutor={tutor} isPaired={false} />
          </div>
        ))}
      </div>
      <div className={props.classes.findMoreTextContainer}>
        <Typography
          dense
          className={props.classes.subtitle}
          gutterBottom
          variant="subtitle2"
          align="center"
        >
          Find more top peer tutors near {props.city}, {props.state}.
        </Typography>
      </div>
      <Grid container direction="row" justify="center" alignItems="center">
        <SecondaryButtonV2 onClick={navigateFindATutor}>
          Find more tutors near {props.city}, {props.state}
        </SecondaryButtonV2>
      </Grid>
    </div>
  );
};
SchoolLanding.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  tutors: PropTypes.array.isRequired,
  city: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
};

export default compose(withStyles)(SchoolLanding);
